import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"

interface adminLeftMenuState {
    selectedMenu: AdminLeftMenuItem | null
}

export enum AdminLeftMenuItem {
    UserManagement,
    Port,
    CargoType,
    UserAnalytics,
    DuplicateCheck,
    DatabaseBackup,
    MarketingMatchingConfig,
    InvalidCheck,
    BulkImportTonnage,
    BulkImportMarketInfo,
}

const initialState: adminLeftMenuState = {
    selectedMenu: null
}

export const AdminLeftMenuSlice = createSlice({
    name: "AdminLeftMenu",
    initialState,
    reducers: {
        setSelectedMenu: (state, action: PayloadAction<AdminLeftMenuItem | null>) => {
            state.selectedMenu = action.payload;
        },
    }
});

export const adminLeftMenuSelector = createSelector(
    (state: RootState) => state.adminLeftMenu,
    (data) => data
);

export const {
    setSelectedMenu
} = AdminLeftMenuSlice.actions;

export default AdminLeftMenuSlice.reducer;